// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"DateField__inputWrapper--fzjgH","display":"DateField__display--kQacu"};